export const tableOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    alwaysShowAllBtns: true,
    noDataText: 'No data',
};

export const BreakLine = {
    whiteSpace: 'normal',
};

export const alingMoney = {
    whiteSpace: 'normal',
    textAlign: 'right'
};

export const cellTachado = {
    textDecoration: "line-through",
    whiteSpace: "normal"
};
